import { BaseOrganizationEndpoints } from './base';
import {
  ResGetApplications,
  PostApplication,
  IApplication,
  IApplicationWithKeys
} from '../types/api-types';

export class Application extends BaseOrganizationEndpoints {
  async create(body: PostApplication) {
    return await this.requestWithStatus<IApplicationWithKeys>(
      'POST',
      '/applications',
      body
    );
  }

  async update(id: string, body: PostApplication) {
    return await this.requestWithStatus<IApplicationWithKeys>(
      'PUT',
      `/applications/${id}`,
      body
    );
  }

  async delete(id: string) {
    return await this.requestWithStatus<IApplication>(
      'DELETE',
      `/applications/${id}`
    );
  }

  async get(id: string) {
    return await this.requestWithStatus<IApplication>(
      'GET',
      `/applications/${id}`
    );
  }

  async all() {
    return await this.requestWithStatus<ResGetApplications>(
      'GET',
      '/applications'
    );
  }
}
